// extracted by mini-css-extract-plugin
export var container = "_vc-0";
export var table = "_vc-2";
export var tableWrapper = "_vc-1";